import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import FuelingContractDetailLayoutPage from './FuelingContractDetailLayoutPage';
import FuelingContractDetailSection from 'features/contracts/sections/FuelingContractDetailSection';
import DataQuery from 'data/DataQuery';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import { Contract_Get } from 'data/endpoints';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import { useQuery } from 'data/hooks/useQuery';
import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import FuelingContractHistoryPage from './FuelingContractHistoryPage';

type Props = {
  fuelingContractId: string;
}

const FuelingContractDetailPage = (props: Props) => {
  // translations
  const tModules = useTranslation("shared\\moduleNames").t;

  // router
  let match = useRouteMatch();
  const { fuelingContractId } = useParams<Props>();

  // fetch data for contract
  const contractQuery: DataQuery = {
    url: Contract_Get,
    routeParams: getRouteParams("contractId", fuelingContractId),
    params: getQueryParams("IsFuelingContract", String(true))
  };
  const { data: contract, loadStatus: contractLoadStatus } = useQuery<ContractFullDTO>(contractQuery, {}, [fuelingContractId]);

  // render
  return (
    <NoContentWrapper data={contract} loadStatus={contractLoadStatus}>
      <Switch>
        <Route path={`${match.path}/history`}>
          <FuelingContractHistoryPage contract={contract} />
        </Route>
        <Route path={`${match.path}/detail`}>
          <FuelingContractDetailLayoutPage
            links={[{ text: tModules("fuelingContractDetail.title") }]}
            showLinkToDetail={false}
          >
            <FuelingContractDetailSection 
              contract={contract}
            />
          </FuelingContractDetailLayoutPage>
        </Route>
      </Switch>
    </NoContentWrapper>
  );
}

export default FuelingContractDetailPage;